import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import { createVNode } from "inferno";
import { Component } from 'inferno';
import { getElOffset } from './utils';
import classnames from 'classnames';
var _getElOffset = getElOffset;

var ActionBar = /*#__PURE__*/function (_Component) {
  _inherits(ActionBar, _Component); // TODO: Make this sticky AF


  function ActionBar(props) {
    var _this;

    _classCallCheck(this, ActionBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionBar).apply(this, arguments));
    _this.state = {
      isSticky: false,
      stickyWidth: undefined
    };
    _this.didScroll = _this.didScroll.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.pollForMovementTimer = undefined;
    _this.offsetFlowNode = undefined;
    _this.pollForMovement = _this.pollForMovement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(ActionBar, [{
    key: "didScroll",
    value: function didScroll(e) {
      var newState = {};
      var flowNode = this._flowingEl; // var isSticky = _getElOffset(flowNode).top < (window.scrollY + this.props.boundary.top) && window.scrollY < this.props.boundary.bottom

      var isSticky = _getElOffset(flowNode).top + flowNode.offsetHeight > window.visualViewport.height + window.scrollY && this.props.boundary.top < window.innerHeight + window.scrollY;

      if (isSticky !== this.state.isSticky) {
        newState['isSticky'] = isSticky;
      }

      var stickyWidth = flowNode.offsetWidth;

      if (stickyWidth !== this.state.stickyWidth) {
        newState['stickyWidth'] = stickyWidth;
      }

      if (Object.keys(newState).length > 0) {
        this.setState(newState);
      }
    }
  }, {
    key: "pollForMovement",
    value: function pollForMovement() {
      if (!this._flowingEl) {
        return this.pollForMovementTimer = requestAnimationFrame(this.pollForMovement);
      }

      var flowNode = this._flowingEl;
      var offset = flowNode.offsetTop - (window.scrollY !== undefined ? window.scrollY : window.pageYOffset);

      if (this.offsetFlowNode !== offset) {
        this.offsetFlowNode = offset;
        this.didScroll();
      }

      this.pollForMovementTimer = requestAnimationFrame(this.pollForMovement);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.pollForMovementTimer = requestAnimationFrame(this.pollForMovement);
      this.didScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.pollForMovementTimer) {
        cancelAnimationFrame(this.pollForMovementTimer);
      }
    }
  }, {
    key: "render",
    value: function render(_ref) {
      var _this2 = this;

      var boundary = _ref.boundary,
          children = _ref.children;
      return createVNode(1, "div", classnames("InfernoFormlib-ActionBarContainer", this.props.className), [createVNode(1, "div", classnames("InfernoFormlib-ActionBar", {
        "InfernoFormlib-ActionBar--hidden": this.state.isSticky
      }), children, 0, null, null, function (e) {
        return _this2._flowingEl = e;
      }), createVNode(1, "div", classnames("InfernoFormlib-ActionBar InfernoFormlib-StickyActionBar", {
        "InfernoFormlib-StickyActionBar--hidden": !this.state.isSticky
      }), children, 0, {
        "style": {
          bottom: boundary.bottom,
          width: this.state.stickyWidth
        }
      })], 4);
    }
  }]);

  return ActionBar;
}(Component);

export { ActionBar as default };